import { TabDetailParameterName } from "@common-modules/dependencies/navigation/tab-detail-panel-parameters";

export class CtTabDetailParameterNames extends TabDetailParameterName {
  static readonly scenariosGridRows;
}
